









































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class InstructionsCollection extends Vue {
  @Prop() form!: any;
  @Prop() collect!: any;

  get locale() {
    return (
      this.$store?.getters?.LOCALIZATION ||
      window.localStorage.getItem("localization") ||
      "not installed"
    );
  }
}
